import { initializeApp } from "firebase/app";
import { collection, getDocs, getFirestore } from "firebase/firestore";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { useAuth } from "../utils/context";
import { firebaseConfig } from "../utils/firebaseConfig";
import notificationSvc from "../utils/notificationSvc";

const Services = () => {
  const app = initializeApp(firebaseConfig);
  const navigate = useNavigate();
  const { cart, setCart } = useAuth();
  const db = getFirestore(app);
  const typeRefs = useRef({});
  const [selectedType, setSelectedType] = useState(null);
  const [services, setServices] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    getServices();
  }, []);

  const getServices = async () => {
    const querySnapshot = await getDocs(collection(db, "Services"));
    let service = [];
    let category = [];
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      const data = doc.data();
      service.push({ ...data, ServiceID: doc.id });
      if (!category.includes(data.Type)) {
        category.push(data.Type);
      }
    });
    setCategories(category);
    setSelectedType(category[0]);
    setServices(service);
  };

  const scrollToType = (type) => {
    const element = typeRefs.current[type].current;
    element.scrollIntoView({ behavior: "smooth", block: "start" });
    setSelectedType(type);
  };

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setSelectedType(entry.target.dataset.type);
        }
      });
    }, options);

    categories.forEach((type) => {
      const element = typeRefs.current[type].current;
      observer.observe(element);
    });

    return () => {
      categories.forEach((type) => {
        const element = typeRefs.current[type]?.current;
        if (element) observer.unobserve(element);
      });
    };
  }, [categories]);

  const handleAddToCart = (service) => {
    const isExists = cart.filter(
      (item) => item.ServiceID === service.ServiceID
    );
    if (isExists.length > 0) {
      setCart(cart.filter((item) => item.ServiceID !== service.ServiceID));
    } else {
      setCart([...cart, service]);
    }
  };

  const handleNext = (e) => {
    e.preventDefault();
    if (!cart.length > 0) {
      return notificationSvc.error("Please select services");
    }
    navigate("/booking-details");
  };

  return (
    <>
      <Header />
      <section className="mt-3 mb-3 pt-3 pb-3">
        <div className="container">
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <div className="form_box p-5">
                <span className="login100-form-title pb-4 pt-4">
                  Book an Appointment
                </span>
                <form
                  className="login100-form validate-form"
                  onSubmit={(e) => handleNext(e)}
                >
                  <ul
                    className="nav nav-pills mb-3 justify-content-center mb-5"
                    id="pills-tab"
                    role="tablist"
                  >
                    {categories.map((category) => {
                      typeRefs.current[category] = React.createRef();
                      return (
                        <li
                          className="nav-item"
                          key={category}
                          role="presentation"
                          onClick={() => scrollToType(category)}
                        >
                          <button
                            className={`nav-link text-dark ${
                              selectedType === category ? "active" : ""
                            }`}
                            id="pills-home-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-home"
                            type="button"
                            role="tab"
                            aria-controls="pills-home"
                            aria-selected="true"
                          >
                            {category}
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                  <div className="tab-content" id="pills-tabContent">
                    {categories.map((category) => {
                      const temp_services = services.filter(
                        (ser) => ser.Type === category
                      );
                      return (
                        <div
                          className="tab-pane fade show active"
                          id="pills-home"
                          ref={typeRefs.current[category]}
                          key={category}
                          data-type={category}
                          role="tabpanel"
                          aria-labelledby="pills-home-tab"
                        >
                          <div className="form_check_box">
                            {temp_services.map((service) => (
                              <article
                                className={`feature2 ${
                                  cart.findIndex(
                                    (crt) => crt.ServiceID === service.ServiceID
                                  ) !== -1
                                    ? "selected"
                                    : ""
                                } `}
                                onClick={() => handleAddToCart(service)}
                                key={service.ServiceID}
                              >
                                <input type="checkbox" id="feature2" />
                                <div>
                                  <span>
                                    <b>{service.Name}</b> <br />
                                    {service.Description}
                                    <br />
                                    &#163;{service.Price}
                                  </span>
                                </div>
                              </article>
                            ))}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="container-login100-form-btn mt-3">
                    <div className="wrap-login100-form-btn">
                      <div className="login100-form-bgbtn" />
                      <button className="login100-form-btn log_sub">
                        Next
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};
export default Services;
